jQuery(function() {
  jQuery('body').on('change','.swatch :radio',function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });
});
$(document).ready(function(){
  $('.slick_slider_activator').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'easeOutElastic',
    nextArrow: '<i class="custom_button fa fa-angle-right"></i>',
    prevArrow: '<i class="custom_button fa fa-angle-left"></i>'
  });

  $('.custom_bottom_slider_active').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2500,
    cssEase: 'linear',
    nextArrow: '<i class="custom_bottom_button fa fa-angle-right"></i>',
    prevArrow: '<i class="custom_bottom_button fa fa-angle-left"></i>'
  });

  $(document).on('click','.swatch-element > label',function(){
    var get_url = $(this).attr('data-id').trim();
    $('.product__photo--singles').each(function(){
      var get_second_url = $(this).attr('data-image-src').trim();
      if(get_second_url == get_url){

        var slideIndex = $(this).index();
        slideIndex = parseInt(slideIndex);

        $('.slick_slider_activator').slickGoTo( slideIndex,true);

      }

    });

  });

  var len = $(".single-option-selector").length;
  if(len < 2){
    $(".single-option-selector").hide();
  }

});
